/**
 * Copyright (c) Qwoach LLC 2024. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 10.01.24
 *
 */
import BaseObject from "@shared/BaseObject.js";

export default class ExitIntentHelper extends BaseObject {

	isEnabled: boolean = true
	callback = null

	constructor(callback) {
		super();
		this.callback = callback
		this.onExitIntentFn = this.onExitIntent.bind(this)
		this.register()
	}

	setEnabled(isEnabled){
		this.isEnabled = isEnabled
	}

	onExitIntent() {
		if(!this.isEnabled){
			return
		}
		this.callback()

	}

	register() {
		console.log("ExitIntentHelper.register")
		document.body.addEventListener('mouseleave', this.onExitIntentFn, false)
	}

	unregister() {
		console.log("ExitIntentHelper.unregister")
		document.body.removeEventListener('mouseleave', this.onExitIntentFn, false)
	}
}
